export default "__VITE_ASSET__BgiQsfgr__"